<template>
  <div class="relative p-4 border-b bg-white">
    <navigation-item v-if="back" class="pin-l">
      <a class="ml-2 cursor-pointer" @click.prevent="currentRoute = back">
        <base-icon name="arrow-left-icon" size="xs" />
      </a>
    </navigation-item>
    <p class="text-center text-black m-0">
      {{ title }}
    </p>
    <navigation-item v-if="closable" class="pin-r">
      <a
        class="mr-2 cursor-pointer text-sh-secondary-darken-75"
        @click.prevent="closeModal"
      >
        <base-icon name="close-icon" size="xs"></base-icon>
      </a>
    </navigation-item>
  </div>
</template>
<script>
import NavigationItem from './ViewHeaderNavigationItem.vue';
import { mapWritableState } from 'pinia';
import { useRouterStore } from '@/store-pinia/router';

export default {
  components: {
    NavigationItem
  },
  props: {
    title: {
      type: String,
      required: true
    },
    closable: {
      type: Boolean,
      default: true,
      required: false
    },
    back: {
      type: String,
      default: null,
      required: false
    }
  },
  computed: {
    ...mapWritableState(useRouterStore, ['currentRoute'])
  },
  methods: {
    closeModal() {
      this.$root.$emit('reset-navigation');
      this.currentRoute = null;
    }
  }
};
</script>
